import React from "react";
import Typewriter from "typewriter-effect";

function Type() {
  return (
    <Typewriter
      options={{
        strings: [
          "Software Developer",
          "Bug Resolver",
          "Freelancer",
          "MERN Stack Developer",
          "Android App Developer",
          "JAVA Developer"
        ],
        autoStart: true,
        loop: true,
        deleteSpeed: 50,
      }}
    />
  );
}

export default Type;
// I love to explore new technologies and never get bored while discovering the latest advancements.
// Embark on a transformative journey with me, your dedicated full-stack web and Android app developer. I specialize in turning visionary concepts into high-performance, cross-platform wonders. From web brilliance to Android mastery, let's craft a digital masterpiece that resonates and captivates. Your vision, my code—let's make magic happen! 🌐📱✨